"use client";

import { HallowABFlag, useMixpanel } from "@packages/ab";
import { usePath, useRouter, useSearch } from "@packages/framework";
import { useRequestMe } from "@packages/sdk";
import { useModal } from "@packages/ui";
import { useCallback } from "react";

import { LockedContent } from "../components/LockedContent";

export const useRedirectToSubscribe = () => {
  const router = useRouter();
  const pathname = usePath();
  const searchParams = useSearch();
  const {
    query: { data: me },
  } = useRequestMe();
  const lockedKidsModal = useModal(LockedContent);
  const { flags } = useMixpanel();
  const isTargetedWebHalfOffFirstYear =
    flags?.[HallowABFlag.WebHalfOffFirstYear]?.isTargeted;

  return useCallback(
    async ({
      newWindow = false,
      redirectBackOnSubscription = true,
      forContent = null,
    } = {}) => {
      let subscribeUrl = isTargetedWebHalfOffFirstYear
        ? "/upgrade/subscribe/sml"
        : "/upgrade/subscribe";
      let switched = false;
      const params = new URLSearchParams();
      if (me?.is_kid) {
        const kidId = me.id;
        switched = Boolean(
          await lockedKidsModal.show({
            title: forContent?.title,
            images: forContent?.images,
          }),
        );
        if (!switched) return;
        params.set("profile", kidId.toString());
      }
      if (redirectBackOnSubscription) {
        const currentSearch = searchParams.toString();
        const fullPath = currentSearch
          ? `${pathname}?${currentSearch}`
          : pathname;
        params.set("redirect", fullPath);
      }
      subscribeUrl += `?${params.toString()}`;
      if (newWindow) window.open(subscribeUrl);
      else if (switched) window.location.assign(subscribeUrl);
      else return router.push(subscribeUrl);
    },
    [
      pathname,
      router,
      searchParams.toString(),
      me?.is_kid,
      lockedKidsModal,
      isTargetedWebHalfOffFirstYear,
    ],
  );
};
